import { t } from 'i18next';
import styles from './EmployerPortalJobs.module.css';
export const jobTitleUI = (item) => {
    return (
        <span className={styles.jobTitleWrapper}>
            <p className={styles.titleHeading} style={{ textAlign: 'left' }}>{item.title}</p>
            <p className={styles.jobLocation}>
                {item.country && t('general.country.' + item.country)} {item.city && ", " + t('general.city.' + item.city)}
            </p>
        </span>
    );
};
